import styled from '@emotion/styled'

export const GenericSectionSliceImageContainer = styled.div`
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    display: block;
    margin-bottom: ${props => (props.lastSlice ? '150px' : 'initial')};
  }
`
